import { Card, Col, Progress, Row, Statistic, Typography } from "antd";
import { ProjectOutlined, CheckCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { MyLoader } from "Components/MyLoader/MyLoader";
import { errorNotification } from "Components/MyNotification";
import ProjectApi from "Api/ProjectApi/ProjectApi";
import { MyText } from "Components/MyText/MyText";
import { Link } from "react-router";
import { defaultSettings } from "css/defaultAntStyles";
const { Text } = Typography;
export const ProjectsInfo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const result = await ProjectApi.getInfoAboutMyProjects();

        setData(result.dto);
      } catch (err) {
        errorNotification(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
  if (isLoading) {
    return <MyLoader centered={true} />;
  }

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12}>
        <Card style={{ borderRadius: 16 }}>
          <Statistic
            title="Активні проекти"
            value={data?.inProcessingCount || 0}
            prefix={<ProjectOutlined />}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12}>
        <Card style={{ borderRadius: 16 }}>
          <Statistic
            title="Завершено проектів"
            value={data?.isEndedCount || 0}
            prefix={<CheckCircleOutlined />}
          />
        </Card>
      </Col>

      <Col span={24}>
        {data?.projectList && data.projectList.length ? (
          <Card
            title="% Виконання по активним проектам"
            style={{ borderRadius: 16 }}
          >
            {data?.projectList.map((project) => {
              return (
                <Link to={`/projects/${project.id || ""}`} key={project.id}>
                  <div style={{ marginBottom: 18 }}>
                    <Text>{project.title || ""}</Text>
                    <Progress
                      strokeColor={defaultSettings.colorPrimary}
                      percent={
                        project.percent ? Math.round(project.percent) : 0
                      }
                      status="active"
                    />
                  </div>
                </Link>
              );
            })}
          </Card>
        ) : (
          <Card>
            <MyText text={"У Вас відсутні проекти в роботі"} />
          </Card>
        )}
      </Col>
    </Row>
  );
};
